import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Tabs, Tab, Box, styled, Container, Grid, Paper, Card, CardMedia, Typography, IconButton } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Header from '../Layout/Header/header';
import Footer from '../Layout/Footer/footer';
import ArowLeft from '../images/sliderArrow/Left Arrow.svg';
import ArowRight from '../images/sliderArrow/Right Arrow.svg';
import img from '../images/Mask group.svg';
import imgHero from '../images/serviceimg/serviceImg.svg';


const contentVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

const contentTransition = {
  type: 'spring',
  stiffness: 120,
  damping: 20,
  duration: 0.3,
};

const Works = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event:any, newValue:any) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ maxWidth: '2000px', margin: '0 auto', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box sx={{ flex: 1 }}>
        <motion.div
          variants={contentVariants}
          initial="initial"
          animate="in"
          exit="out"
          transition={contentTransition}
        >
          <Box sx={{ py: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 }, px: { xs: 2, md: 6.4 } }}>
            <Grid container spacing={{ xs: 1, md: 0 }} alignItems="center">
              <Grid item xs={12} md={7}>
                <Box>
                  <Typography sx={{ fontWeight: 700, color: '#333333', fontSize: { xs: '22px', md: '32px' } }}>
                    Our Work
                  </Typography>
                  <ul
                    className="service-ul-font-size"
                    style={{
                      paddingLeft: '20px',
                      marginTop: '20px',
                      fontSize: '16px',
                      fontWeight: 400,
                      lineHeight: '28px',
                      fontFamily: 'Roboto',
                    }}
                  >
                    <li>Expert Advice And Guidance For Construction Projects of All Sizes.</li>
                    <li>Project Planning And Management Services.</li>
                    <li>Assistance In Sourcing Materials And Contractors.</li>
                    <li>Quality Control And Compliance Assurance.</li>
                  </ul>
                </Box>
              </Grid>
              <Grid item xs={12} md={5}>
                <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}>
                  <img src={imgHero} alt="hero-img" style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                </Paper>
              </Grid>
            </Grid>
          </Box>

          <Container sx={{ mb: 3 }}>
            <Box sx={{ overflowX: 'auto' }}>
              <Tabs
                sx={{
                  borderBottom: '2px solid #D9D9D9',
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#89652A',
                    height: '2px',
                  },
                }}
                value={value}
                onChange={handleChange}
                textColor="inherit"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab sx={tabStyles} label="All" />
                <Tab sx={tabStyles} label="Home Construction" />
                <Tab sx={tabStyles} label="Interior Design" />
                <Tab sx={tabStyles} label="Renovations" />
              </Tabs>
            </Box>
          </Container>

          <Box>
            {['All', 'Home Construction', 'Interior Design', 'Renovations'].map((category, index) => (
              <Box key={index} position="relative" sx={{ display: value === index ? 'block' : 'none' }}>
                <Carousel
                  showStatus={false}
                  showIndicators={false}
                  showThumbs={false}
                  infiniteLoop
                  centerMode
                  centerSlidePercentage={60}
                  swipeable={false}
                  emulateTouch={false}
                  renderArrowPrev={(onClickHandler, hasPrev, label) =>
                    hasPrev && (
                      <IconButton
                        onClick={onClickHandler}
                        sx={{ position: 'absolute', left: { xs: 4, md: 100 }, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }}
                      >
                        <img src={ArowLeft} alt="Left Arrow" className="slider-arrow" style={{ height: '54px', width: '54px' }} />
                      </IconButton>
                    )
                  }
                  renderArrowNext={(onClickHandler, hasNext, label) =>
                    hasNext && (
                      <IconButton
                        onClick={onClickHandler}
                        sx={{ position: 'absolute', right: { xs: 4, md: 100 }, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }}
                      >
                        <img src={ArowRight} alt="Right Arrow" className="slider-arrow" style={{ height: '54px', width: '54px' }} />
                      </IconButton>
                    )
                  }
                >
                  {projects.map((project) => (
                    <Card elevation={0} key={project.id} style={{ margin: '5px', position: 'relative' }}>
                      <CardMedia
                        component="img"
                        sx={{
                          height: {
                            xs: 160,
                            sm: 290,
                            md: 400,
                            lg: 400,
                          },
                        }}
                        image={project.image}
                        alt={project.name}
                      />
                      <Box
                        sx={{
                          border: '1px solid #FFFFFF80',
                          position: 'absolute',
                          bottom: { xs: '10px', md: '48px' },
                          left: '50%',
                          transform: 'translateX(-50%)',
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          padding: { xs: '8px 16px', md: '16px 24px' },
                          borderRadius: '8px',
                          color: 'white',
                          textAlign: 'center',
                          minWidth: { xs: '130px', md: '200px' },
                          width: { xs: '80%', md: 'auto' },
                        }}
                      >
                        <Typography sx={{ mb: { xs: 0.5, md: 0 }, fontWeight: 700, fontSize: { xs: '13px', md: '30px' } }}>
                          {project.name}
                        </Typography>
                        <Typography sx={{ fontWeight: 500, fontSize: { xs: '11px', md: '22px' }, mb: { xs: 0.25, md: 0.5 } }}>
                          Location: {project.location}
                        </Typography>
                        <Typography sx={{ fontWeight: 500, fontSize: { xs: '10px', md: '22px' } }}>
                          Completed in Days: {project.completedInDays}
                        </Typography>
                      </Box>
                    </Card>
                  ))}
                </Carousel>
              </Box>
            ))}
          </Box>
        </motion.div>
      </Box>
      <Footer />
    </Box>
  );
};

export default Works;



const projects = [
  {
    id: 1,
    name: 'Skyline Heights',
    location: 'Mumbai',
    completedInDays: 267,
    image:img,
    category: 'Home Construction',
  },
  {
    id: 2,
    name: 'Urban Nest',
    location: 'Delhi',
    completedInDays: 45,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    category: 'Interior Design',
  },
  {
    id: 3,
    name: 'Green Villa',
    location: 'Bangalore',
    completedInDays: 60,
    image: 'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=800&q=80',
    category: 'Renovations',
  },
  {
    id: 4,
    name: 'Sunset Residency',
    location: 'Pune',
    completedInDays: 38,
    image: 'https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?auto=format&fit=crop&w=800&q=80',
    category: 'Home Construction',
  },
  {
    id: 5,
    name: 'Modern Loft',
    location: 'Hyderabad',
    completedInDays: 90,
    image: 'https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?auto=format&fit=crop&w=800&q=80',
    category: 'Interior Design',
  },
  {
    id: 6,
    name: 'Classic Mansion',
    location: 'Chennai',
    completedInDays: 280,
    image: 'https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?q=80&w=958&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    category: 'Renovations',
  },
];

const tabStyles = {
  textTransform: 'none',
  minWidth: 'auto',
  fontWeight: 500,
  fontSize: { xs: '14px', md: '18px' },
  paddingBottom: '8px',
  '&.Mui-selected': {
    color: '#161717',
  },
};
